import { fetch } from '../../Common/fetch';
import {
    CreateThermometerEntryRequest,
    ThermometerDataPoint,
} from '../modules/interfaces';

export async function createThermometerEntry(
    newThermometerData: CreateThermometerEntryRequest,
) {
    return fetch(`/api/Thermometer`, 'post', newThermometerData);
}

export async function getThermometerEntries(): Promise<ThermometerDataPoint[]> {
    return fetch(`/api/thermometer`);
}
